import { SamplesBudgetApiClient } from '@fourthwall/services/dist/SamplesBudgetApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useAffiliateReferralsQuery = createQueryHook(
  SamplesBudgetApiClient.getAffiliateReferrals,
  {
    queryKey: ['affiliateReferrals'],
  },
)
